import '../../styles/triple-oaks.css';
import tree from "url:../../assets/trok/trok-tree.png";
import leaves from "url:../../assets/trok/trok-leaves.png";
import leaf from "url:../../assets/trok/trok-leaf.png";
import email from "url:../../assets/trok/trok-email.png";
import { WebmastersLair } from './WebmastersLair';
import { Stamp, StampType } from '../../components/Stamp';
import { StampCollection } from '../../components/StampCollection';
import { Smashable } from '../../components/cursor/Smashable';
import { ReactNode, useContext } from 'react';
import ExecProvider from '../../providers/ExecProvider';
import { Outlet, useNavigate } from 'react-router';
import TripleOaksProvider from './TripleOaksProvider';
import { Plzen } from '../../components/cursor/plz/Plzen';

export function TROK0()
{
    const execProvider = useContext(ExecProvider.context);
    const style = execProvider.cmds.includes('iamblue') ? 'bg-clue' : 'trok-bg';

    return <TripleOaksProvider value={{}}>
        <div className={"page-basic " + style}>
            <div className='trok-header-box height-256 h-box center-all gap-16'>
                <Smashable><img id='lefttree' className='filter-black height-128' src={tree} /></Smashable>
                <div className='v-box gap-8'>
                    <Smashable><h1 className='trok-text text-48 shadow-black compact'>Triple Oaks<br/>Municipal Website</h1></Smashable>
                    <Smashable><h3 className='trok-text text-24 font-italic compact'>Piscis in capulus factorem.</h3></Smashable>
                </div>
                <Smashable><img className='trok-leaves' src={leaves} /></Smashable>
            </div>
            <div className='trok-body-width h-box gap-32'>
                <div className='trok-side-width'>
                    <TripleOaksNav />
                    <div style={{height: 128}} />
                </div>
                <Outlet />
                <div className='trok-side-width v-box gap-16'>
                    <Smashable>
                        <div className='trok-info v-box'>
                            <div className='v-box text-center center-all padding-4 height-64 text-24 font-gill trok-text-color trok-body-color'>Today's Status</div>
                            <div className='trok-info-body'>
                                <div className='trok-info-weather'>
                                    <span className='trok-info-quote'>🥺🙏 <b>Hopeful</b></span>
                                    <br/>
                                    64° and ☁️ Cloudy
                                </div>
                            </div>
                        </div>
                    </Smashable>
                    <Smashable>
                        <div className='trok-info v-box'>
                            <div className='v-box text-center center-all padding-4 height-64 text-24 font-gill trok-text-color trok-body-color'>Today's Quote</div>
                            <div className='trok-info-body'>
                                <span className='trok-info-quote'>"And we said, behold and benot befraid. The answers are before your eyes."</span>
                                <br/>
                                <span className='trok-info-quote'>Gorks 11:43</span>
                            </div>
                        </div>
                    </Smashable>
                    <div className='height-64' />
                    <Smashable>
                        <div className='trok-info v-box'>
                            <div className='v-box text-center center-all padding-4 text-24 font-gill trok-text-color trok-body-color pos-rel'>
                                <img src={email} className='trok-email-icon' />
                                Contact the Webmaster
                                <Plzen onState={
                                    <button>Click Here!!!</button>
                                } offState={
                                    <button className='bg-black text-gray-dark'>Click Here</button>
                                } stdOnClick={() => {
                                    window.location.href = 'mailto:webmaster@tripleoaks.org'
                                }} />
                            </div>
                        </div>
                    </Smashable>
                    <div className='height-64' />
                    <StampCollection stamps={[
                        StampType.Anime,
                        StampType.TacoBongo,
                        StampType.WTROK,
                        StampType.Cryptid,
                        StampType.Weblair,
                        StampType.Phranks
                    ]} />
                </div>
            </div>
            <WebmastersLair />
        </ div>
    </TripleOaksProvider>
}

function TripleOaksNav()
{
    const navigate = useNavigate();

    return <div className='trok-leaf-buttons'>
        <div className='trok-leaf-button'>
            <img className='trok-leaf-button-a' src={leaf} width='100%'/>
            <span className='trok-leaf-button-text' onClick={() => navigate('/tripleoaks/')}>Site Map</span>
        </div>
        <div className='trok-leaf-button'>
            <img className='trok-leaf-button-b' src={leaf} width='100%'/>
            <span className='trok-leaf-button-text' onClick={() => navigate('/tripleoaks/construction')}>News & Events</span>
        </div>
        <div className='trok-leaf-button'>
            <img className='trok-leaf-button-a' src={leaf} width='100%'/>
            <span className='trok-leaf-button-text' onClick={() => navigate('/tripleoaks/lost')}>What To Do</span>
        </div>
        <div className='trok-leaf-button'>
            <img className='trok-leaf-button-b' src={leaf} width='100%'/>
            <span className='trok-leaf-button-text' onClick={() => navigate('/tripleoaks/what')}>Our History</span>
        </div>
    </div>;
}